import {useDispatch, useSelector} from 'react-redux'
import {actions} from 'store/modules/authentication/actions'
import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import logo from 'assets/images/logo.png'

export const Login = () => {
  const navigate = useNavigate()

  const [email, setEmail] = useState('')
  const [error, setError] = useState(null)

  const dispatch = useDispatch()
  const {loading = false, error: isError} = useSelector(state => state.authentication)

  const onSuccess = data => {
    navigate(`/authentication/verify-otp/${btoa(email)}`)
  }

  const onError = e => {
    setError(e.message)
  }

  const handleAuth = () => {
    setError(null)
    dispatch(
      actions.login({
        email,
        onSuccess,
        onError
      })
    )
  }

  return (
    <div className="vw-login">
      <p className="text-xs opacity-25" style={{position: 'absolute', bottom: 0}}>
        v{process.env.REACT_APP_VERSION}
      </p>
      <div className="vw-login__block">
        <div className="vw-login__block__form">
          <img src={logo} alt="Video Window Logo" />
          <div className="form-group">
            <label>Email address</label>
            <input
              value={email}
              onChange={({target: {value}}) => setEmail(value)}
              className="form-control"
              type="email"
              placeholder="Enter email"
              name="email"
              required
              autoFocus
            />
            {isError && <div className="text-danger text-sm mt-2">{error}</div>}
          </div>
          <div className="form-group form-check d-flex">
            <input type="checkbox" className="form-check-input" name="remember" />
            <label className="form-check-label">Remember me</label>
          </div>
          <button type="button" className="btn btn-primary btn-block" onClick={handleAuth}>
            {loading ? (
              <span className="spinner-border spinner-border-sm text-light" role="status"></span>
            ) : (
              <span>Next</span>
            )}
          </button>
        </div>
        <div className="vw-login__block__welcome"> </div>
      </div>
    </div>
  )
}
